import type { Finding, Section } from "../api/types";
import { chainage } from "../lib/format";
import { CONDITION_COLOR } from "./Badges";

/** The road drawn as a bar from km 0+000 to its end: sections coloured by condition, findings as ticks. */
export function ChainageStrip({ lengthKm, sections, findings = [] }: { lengthKm: number; sections: Section[]; findings?: Finding[] }) {
  const total = Math.max(lengthKm * 1000, 1);
  const segs = sections.length
    ? sections.map((s) => ({
        w: Math.max(((s.end_m ?? 0) - (s.start_m ?? 0)) / total, 0),
        color: CONDITION_COLOR[(s.condition_band || "").replace(/^./, (c) => c.toUpperCase())] ?? CONDITION_COLOR["Not rated"],
        title: `${chainage(s.start_m)} – ${chainage(s.end_m)}: ${s.condition_band || "Not rated"}`,
      }))
    : [{ w: 1, color: CONDITION_COLOR["Not rated"], title: "No condition assessment yet" }];

  const marks = [0, 0.25, 0.5, 0.75, 1].map((f) => chainage(f * total));
  return (
    <figure style={{ margin: 0 }} aria-label="Condition along the road">
      <div className="strip">
        {segs.map((s, i) => <span key={i} title={s.title} style={{ width: `${s.w * 100}%`, background: s.color, opacity: sections.length ? 1 : 0.35 }} />)}
      </div>
      {findings.length ? (
        <div className="ticks" aria-hidden="true">
          {findings.filter((f) => f.chainage_m !== null).map((f) => (
            <b key={f.id} title={`${f.type_name} at ${chainage(f.chainage_m)}`}
               style={{ left: `${Math.min((f.chainage_m! / total) * 100, 100)}%`, background: f.status === "verified" ? "var(--navy)" : "var(--fair)", opacity: f.status === "verified" ? 1 : 0.6 }} />
          ))}
        </div>
      ) : null}
      <figcaption className="strip-scale">{marks.map((m) => <span key={m}>{m}</span>)}</figcaption>
    </figure>
  );
}
